export default "__VITE_ASSET__DGu0FG$D__"